import React from "react";
import { useTranslation } from "react-i18next";
import { useAdminControls } from "../../state/AdminControlsContext";
import { TimeRangeControl } from "./TimeRangeControl";
import "./shell.css";

/**
 * Topbar: live search (feeds the Users table) + the Tag/Woche/Monat time-range
 * toggle + custom Von/Bis picker (feeds the Dashboard). Both live in
 * AdminControls so the routed screens can read them. The admin/logout panel
 * lives at the bottom of the Sidebar, not here.
 */
export const Topbar: React.FC = () => {
  const { search, setSearch } = useAdminControls();
  const { t } = useTranslation();

  return (
    <header className="topbar">
      <input
        className="topbar-search"
        type="text"
        placeholder={t("topbar.searchPlaceholder")}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="topbar-right">
        <TimeRangeControl />
      </div>
    </header>
  );
};
